import React, { useEffect, useState } from "react";
import { Box } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid/";
import { useSelector } from "react-redux";
import { ButtonLink } from "../../../../lib";
import { WatchActions } from "../../../../state";
import { format } from "date-fns";

export function RecentlyChangedRecords(props) {
  const siteId = useSelector((state) => state.scopes.site_id);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    (async function () {
      const recentlyChanged = await WatchActions.getRecentlyChanged(siteId);
      setRows(recentlyChanged || []);
    })();
  }, [siteId]);

  const renameValues = rows?.map((row) => ({
    id: row.item_id,
    date: format(new Date(row.date_changed), "MMM-do yyyy h:mm a"),
    model_no: row.item?.model_no,
    changedBy: row.changed_by,
    button: row.item_id,
  }));

  const columns = [
    {
      field: "id",
      headerName: "ID",
      flex: 0.4,
      headerAlign: "center",
      align: "center",
    },
    { field: "date", headerName: "Date Changed", flex: 0.7 },
    {
      field: "model_no",
      headerName: "Model",
      flex: 1.5,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "changedBy",
      headerName: "Changed By",
      flex: 0.7,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "button",
      headerName: "History",
      flex: 0.5,
      filterable: false,
      sortable: false,
      renderCell: (params) => {
        return (
          <ButtonLink
            variant="outlined"
            color="primary"
            size="small"
            to={`/history/${params.value}`}
          >
            View
          </ButtonLink>
        );
      },
      headerAlign: "left",
      align: "left",
    },
  ];

  return (
    <Box style={{ width: "100%" }}>
      <div style={{ display: "flex", justifyContent: "center" }}></div>
      <div>
        {rows && (
          <DataGrid
            rows={renameValues}
            columns={columns}
            disableColumnMenu={true}
            isRowSelectable={false}
            pageSize={100}
            checkboxSelection={false}
            autoHeight={true}
            rowHeight={38}
          />
        )}
      </div>
    </Box>
  );
}
